import React from "react";
import SalesAdminLoginTrackingReportComponent from "../Components/MHL_Reports/SalesAdminLoginTrackingReportComponent";

const SalesAdminLoginTrackingReportPage = () => {
  return (
    <div>
      <SalesAdminLoginTrackingReportComponent />
    </div>
  );
};

export default SalesAdminLoginTrackingReportPage;
